/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useDisclosure } from "@jumbo/components/JumboDialog/hooks/useDisclosure";

import Stack from "@mui/material/Stack";
import { Typography } from "@mui/material";
import { Card, CardContent } from "@mui/material";

import { usePagination } from "app/hooks/usePagination";
import { Table } from "app/components";
import { useDispatch, useSelector } from "react-redux";
import Loader from "@jumbo/components/Loader";
import moment from "moment";
import { getSampleReturnList } from "app/redux/slice/sampleReturnSlice";
import { useNavigate, useParams } from "react-router-dom";
import { LoadingButton } from "@mui/lab";
import { SAMPLES } from "app/routes/constant";

const SampleManagementReturn = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const { stageAction } = useDisclosure();
  const dispatch = useDispatch();

  const sampleData = useSelector((state) => state?.sampleReturn);

  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("createdAt");

  const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage } =
    usePagination({ id: "uniqueVariant" });

  const columns = [
    {
      id: "returnDate",
      label: "Return Date",
      sort: true,
      render: (elm) => <> {moment(elm?.returnDate).format("DD/MM/YYYY")}</>,
    },
    {
      id: "sampleNumber",
      label: "Sample No",
      render: (elm) => <> {elm.sampleId.sampleNumber}</>,
    },
    {
      id: "productId",
      label: "Product",
      render: (row) => <>{row?.productId?.name}</>,
    },
    {
      id: "variantId",
      label: "Product Variant",
      render: (row) => <>{row?.variantId?.name ?? "-"}</>,
    },
    {
      id: "returnQuantity",
      label: "Return Quantity",
      render: (row) => <>{row?.returnQuantity}</>,
    },
  ];

  const getData = () => {
    const value = {
      page: page,
      perPage: rowsPerPage,
      sampleId: id,
    };
    if (orderBy !== "") {
      value.sort = order === "asc" ? 1 : -1;
      value.field = orderBy;
    }
    dispatch(getSampleReturnList(value));
  };

  const sortData = (Order, OrderBy) => {
    setOrder(Order);
    setOrderBy(OrderBy);
  };

  useEffect(() => {
    getData();
  }, [page, rowsPerPage, dispatch, order, orderBy]);

  return (
    <>
      {sampleData?.loading ? (
        <Loader />
      ) : (
        <>
          <Card>
            <CardContent>
              <Stack
                justifyContent="space-between"
                direction={{ xs: "column", sm: "row" }}
                sx={{ mb: 3 }}
              >
                <Typography variant={"h2"} mb={0}>
                  Sample Product Return List
                </Typography>
                <LoadingButton
                  onClick={() => {
                    navigate(SAMPLES);
                  }}
                  type="submit"
                  variant="contained"
                  sx={{
                    mt: { xs: 1, md: 0 },
                  }}
                >
                  BacK
                </LoadingButton>
              </Stack>
              <Table
                columns={columns}
                rows={sampleData?.list}
                page={page}
                rowsPerPage={rowsPerPage}
                Order={order}
                count={sampleData?.total}
                OrderBy={orderBy}
                sortData={sortData}
                handleChangePage={handleChangePage}
                handleChangeRowsPerPage={handleChangeRowsPerPage}
                editAction={stageAction}
              />
            </CardContent>
          </Card>
        </>
      )}
    </>
  );
};

export default SampleManagementReturn;
